import * as PIXI from 'pixi.js'
import { containers, gameAssets } from '../gameUI';
import { scaleFactor, tweenFade, tweenFadeAppear } from '../utility';
import { resetGameSettings, showJackpots } from '../gameLogic';
import gsap from 'gsap';
import { networkData } from '../data';

let timeoutId;

export function createLoseScreenText() {
    if (!gameAssets.loseMessage) {
        gameAssets.loseMessage = new PIXI.Container();
        gameAssets.loseMessage.zIndex = 7001;

        const text1 = new PIXI.BitmapText("Try", {
            fontName: "font-export",
            fontSize: 18,
            align: "center",
            letterSpacing: -10,
        });

        const text2 = new PIXI.BitmapText("Again!", {
            fontName: "font-export",
            fontSize: 18,
            align: "center",
            letterSpacing: -10,
        });

        text1.anchor.set(0.5);
        text2.anchor.set(0.5);

        // Add to container
        gameAssets.loseMessage.addChild(text1, text2);

        // Center horizontally and position vertically
        text1.x = 0;
        text1.y = 0;

        const spacing = -3; // adjust this value for more/less gap between lines
        text2.x = 0;
        text2.y = text1.height + spacing;
        const lWidth = gameAssets.loseMessage.width

        gameAssets.loseMessage.resize = (w, h) => {
            const expandFactor = 0.37;
            const scale = scaleFactor(gameAssets.gameScreen.width, lWidth);

            gameAssets.loseMessage.x = w * 0.5;
            gameAssets.loseMessage.y = h * 0.7;
            gameAssets.loseMessage.scale.set(scale * expandFactor);
        };

        if (!gameAssets.hideLoseScreenBtnGraphic) {
            gameAssets.hideLoseScreenBtnGraphic = new PIXI.Graphics();
        }

        gameAssets.hideLoseScreenBtnGraphic.beginFill(0xff0000, 1);
        gameAssets.hideLoseScreenBtnGraphic.drawRect(
            -gameAssets.loseMessage.width * 6 / 2,
            -gameAssets.loseMessage.height * 6 / 2,
            gameAssets.loseMessage.width * 6,
            gameAssets.loseMessage.height * 6
        );
        gameAssets.hideLoseScreenBtnGraphic.endFill();

        gameAssets.hideLoseScreenBtnGraphic.alpha = 0.01;
        gameAssets.hideLoseScreenBtnGraphic.visible = false;
        gameAssets.hideLoseScreenBtnGraphic.interactive = false;
        gameAssets.hideLoseScreenBtnGraphic.buttonMode = false;
        gameAssets.hideLoseScreenBtnGraphic.cursor = 'pointer';

        gameAssets.loseMessage.visible = false;
        gameAssets.loseMessage.addChild(gameAssets.hideLoseScreenBtnGraphic);
        containers.bgContainer.addChild(gameAssets.loseMessage);

        gameAssets.hideLoseScreenBtnGraphic.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                clearTimeout(timeoutId);
                hideLoseScreen();
            }
        });
    }
}

// const timeout = ()=> setTimeout(() => {
//     console.log("rgfkljreiogiopovog");
//     hideLoseScreen()
// }, 3000)


function hideLoseScreen() {

    tweenFade(gameAssets.dimmer, false);
    tweenFade(gameAssets.loseMessage, false);
    gameAssets.dimmer.visible = false
    gameAssets.loseMessage.visible = false

    gameAssets.hideLoseScreenBtnGraphic.visible = false;
    gameAssets.hideLoseScreenBtnGraphic.interactive = false;
    gameAssets.autoPlayDisable.visible = false
    gameAssets.turboPlayDisable.visible = false;

    if (networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin) {
        showJackpots();
    } else {
        resetGameSettings(0);
    }
}

export function showLose() {
    gameAssets.autoPlayDisable.visible = true
    gameAssets.turboPlayDisable.visible = true;
    gameAssets.hideLoseScreenBtnGraphic.visible = true
    // gameAssets.dimmer.visible = true
    gameAssets.hideLoseScreenBtnGraphic.interactive = true
    gameAssets.hideLoseScreenBtnGraphic.buttonMode = true
    // tweenFade(gameAssets.dimmer, true);
    tweenFade(gameAssets.loseMessage, true)
    timeoutId = setTimeout(() => {
        hideLoseScreen();
    }, 1000);
}

